import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import * as CatizColors from './Colors';
import WindowHeader from './WindowHeader';

const Container = styled.div`
  ${CatizColors.grayBorder}
`;

export default function AlphaRVideoArea() {
  return (
    <Container>
      <WindowHeader name={'Alpha R Video'} />
    </Container>
  );
}
